import http from '../../../http-common';

export function requestLoadBancos() {
    return http.get('/bancos');
}

export function requestSaveBanco(banco) {
    return http.post('/bancos', banco);
}
